import {
  ShoppingCart, Users, Store, Landmark, UserCog, Monitor, MoreHorizontal,
  Pill, ShoppingBasket, Sparkles, Baby,
  Banknote, Star, Clock, FileText, HandCoins, GraduationCap, Shield, Stethoscope, Award,
  Zap, Droplet, Wifi, Home, Truck, Wrench, Brush,
  CreditCard, ArrowLeftRight, Receipt, CircleDollarSign, BarChart, RefreshCcw,
  Calculator, Scale, Laptop, Handshake, ShieldCheck,
  Stamp, MapPin, AlertTriangle,
  Armchair, Settings, Snowflake, Fan, Hammer, Car
} from 'lucide-react';

export const EXPENSE_CATEGORIES = [
  {
    id: 'Achats médicaments',
    label: 'Achats médicaments',
    description: 'Médicaments et produits pour la pharmacie',
    icon: ShoppingCart,
    color: 'text-red-500',
    bgColor: 'bg-red-50',
    subcategories: [
      { id: 'Médicaments', label: 'Médicaments', desc: 'Spécialités et génériques', icon: Pill, color: 'text-green-500', bgColor: 'bg-green-50' },
      { id: 'Parapharmacie', label: 'Parapharmacie', desc: 'Hygiène, soins, bien-être', icon: ShoppingBasket, color: 'text-purple-500', bgColor: 'bg-purple-50' },
      { id: 'Cosmétiques', label: 'Cosmétiques', desc: 'Beauté, soins esthétiques', icon: Sparkles, color: 'text-yellow-500', bgColor: 'bg-yellow-50' },
      { id: 'Produits infantiles', label: 'Produits infantiles', desc: 'Bébé, maternité', icon: Baby, color: 'text-blue-500', bgColor: 'bg-blue-50' },
      { id: 'Autre_Achats', label: 'Autre', desc: 'Autres achats médicaments', icon: MoreHorizontal, color: 'text-gray-500', bgColor: 'bg-gray-100' }
    ]
  },
  {
    id: 'Salaires & personnel',
    label: 'Salaires & personnel',
    description: 'Salaires, primes, indemnités, formation, frais de personnel...',
    icon: Users,
    color: 'text-green-600',
    bgColor: 'bg-green-50',
    subcategories: [
      { id: 'Salaire personnel', label: 'Salaire personnel', desc: 'Salaires des employés', icon: Banknote, color: 'text-pink-500', bgColor: 'bg-pink-50' },
      { id: 'Primes', label: 'Primes', desc: 'Primes et bonus', icon: Star, color: 'text-yellow-500', bgColor: 'bg-yellow-50' },
      { id: 'Heures supplémentaires', label: 'Heures supplémentaires', desc: 'Paiement des heures supp', icon: Clock, color: 'text-blue-500', bgColor: 'bg-blue-50' },
      { id: 'Indemnités', label: 'Indemnités', desc: 'Indemnités diverses', icon: FileText, color: 'text-purple-500', bgColor: 'bg-purple-50' },
      { id: 'Avance sur salaire', label: 'Avance sur salaire', desc: 'Avances versées', icon: HandCoins, color: 'text-green-500', bgColor: 'bg-green-50' },
      { id: 'Stagiaires / Remplacements', label: 'Stagiaires / Remplacements', desc: 'Rémunération stagiaires', icon: GraduationCap, color: 'text-purple-500', bgColor: 'bg-purple-50' },
      { id: 'Formation', label: 'Formation', desc: 'Frais de formation', icon: Users, color: 'text-pink-500', bgColor: 'bg-pink-50' },
      { id: 'Assurance personnel', label: 'Assurance personnel', desc: 'Mutuelle, assurance', icon: Shield, color: 'text-teal-500', bgColor: 'bg-teal-50' },
      { id: 'Médecine du travail', label: 'Médecine du travail', desc: 'Visites médicales', icon: Stethoscope, color: 'text-orange-500', bgColor: 'bg-orange-50' },
      { id: 'Avantages en nature', label: 'Avantages en nature', desc: 'Avantages divers', icon: Award, color: 'text-blue-500', bgColor: 'bg-blue-50' },
      { id: 'Autres charges personnel', label: 'Autres charges personnel', desc: 'Autres charges', icon: MoreHorizontal, color: 'text-gray-500', bgColor: 'bg-gray-100' },
      { id: 'Autre_Salaires', label: 'Autre', desc: 'Autres frais personnel', icon: MoreHorizontal, color: 'text-gray-500', bgColor: 'bg-gray-100' }
    ]
  },
  {
    id: 'Charge et exploitation',
    label: 'Charge et exploitation',
    description: 'Charges de fonctionnement de la pharmacie',
    icon: Store,
    color: 'text-pink-500',
    bgColor: 'bg-pink-50',
    subcategories: [
      { id: 'Électricité & Gaz', label: 'Électricité & Gaz', desc: 'Sonelgaz, consommation', icon: Zap, color: 'text-yellow-500', bgColor: 'bg-yellow-50' },
      { id: 'Eau', label: 'Eau', desc: 'ADE, consommation', icon: Droplet, color: 'text-blue-500', bgColor: 'bg-blue-50' },
      { id: 'Téléphone & Internet', label: 'Téléphone & Internet', desc: 'Algérie Télécom, Ooredoo...', icon: Wifi, color: 'text-purple-500', bgColor: 'bg-purple-50' },
      { id: 'Loyer', label: 'Loyer', desc: 'Loyer du local, charges', icon: Home, color: 'text-green-500', bgColor: 'bg-green-50' },
      { id: 'Transport & carburant', label: 'Transport & carburant', desc: 'Carburant, déplacement', icon: Truck, color: 'text-orange-500', bgColor: 'bg-orange-50' },
      { id: 'Maintenance & réparations', label: 'Maintenance & réparations', desc: 'Matériel, local', icon: Wrench, color: 'text-pink-500', bgColor: 'bg-pink-50' },
      { id: 'Nettoyage & entretien', label: 'Nettoyage & entretien', desc: 'Produits d\'entretien', icon: Brush, color: 'text-teal-500', bgColor: 'bg-teal-50' },
      { id: 'Fournitures de bureau', label: 'Fournitures de bureau', desc: 'Papeterie, impressions', icon: FileText, color: 'text-purple-500', bgColor: 'bg-purple-50' },
      { id: 'Assurances', label: 'Assurances', desc: 'Assurance local, matériel', icon: Shield, color: 'text-blue-500', bgColor: 'bg-blue-50' },
      { id: 'Autre charge d\'exploitation', label: 'Autre charge d\'exploitation', desc: 'Autres frais', icon: MoreHorizontal, color: 'text-gray-500', bgColor: 'bg-gray-100' }
    ]
  },
  {
    id: 'Banque et finance',
    label: 'Banque et finance',
    description: 'Frais bancaires, commissions, emprunts, placements...',
    icon: Landmark,
    color: 'text-blue-500',
    bgColor: 'bg-blue-50',
    subcategories: [
      { id: 'Frais bancaires', label: 'Frais bancaires', desc: 'Tenue de compte', icon: CreditCard, color: 'text-purple-500', bgColor: 'bg-purple-50' },
      { id: 'Virements', label: 'Virements', desc: 'Frais de virement bancaire', icon: ArrowLeftRight, color: 'text-green-500', bgColor: 'bg-green-50' },
      { id: 'Chèques', label: 'Chèques', desc: 'Frais de chéquier, rejet', icon: Receipt, color: 'text-blue-500', bgColor: 'bg-blue-50' },
      { id: 'Intérêts d\'emprunt', label: 'Intérêts d\'emprunt', desc: 'Emprunts, crédits', icon: HandCoins, color: 'text-orange-500', bgColor: 'bg-orange-50' },
      { id: 'Assurance crédit', label: 'Assurance crédit', desc: 'Assurances liées aux financements', icon: CircleDollarSign, color: 'text-pink-500', bgColor: 'bg-pink-50' },
      { id: 'Placement & épargne', label: 'Placement & épargne', desc: 'Dépôts, placements', icon: BarChart, color: 'text-teal-500', bgColor: 'bg-teal-50' },
      { id: 'Change', label: 'Change', desc: 'Frais de change devise', icon: RefreshCcw, color: 'text-purple-500', bgColor: 'bg-purple-50' },
      { id: 'Autre_Finance', label: 'Autre', desc: 'Autres frais financiers', icon: MoreHorizontal, color: 'text-gray-500', bgColor: 'bg-gray-100' }
    ]
  },
  {
    id: 'Honoraires & services',
    label: 'Honoraires & services',
    description: 'Prestations professionnelles et services externes',
    icon: UserCog,
    color: 'text-purple-500',
    bgColor: 'bg-purple-50',
    subcategories: [
      { id: 'Comptable / Expert-comptable', label: 'Comptable / Expert-comptable', desc: 'Comptabilité, fiscalité', icon: Calculator, color: 'text-green-500', bgColor: 'bg-green-50' },
      { id: 'Avocat & juridique', label: 'Avocat & juridique', desc: 'Conseil, rédaction', icon: Scale, color: 'text-orange-500', bgColor: 'bg-orange-50' },
      { id: 'Conseil & consulting', label: 'Conseil & consulting', desc: 'Etudes, formations', icon: Users, color: 'text-blue-500', bgColor: 'bg-blue-50' },
      { id: 'Prestations informatiques', label: 'Prestations informatiques', desc: 'Logiciels, maintenance', icon: Laptop, color: 'text-pink-500', bgColor: 'bg-pink-50' },
      { id: 'Prestataires externes', label: 'Prestataires externes', desc: 'Etudes, analyses', icon: Handshake, color: 'text-yellow-500', bgColor: 'bg-yellow-50' },
      { id: 'Gardiennage & sécurité', label: 'Gardiennage & sécurité', desc: 'Sécurité, surveillance', icon: ShieldCheck, color: 'text-purple-500', bgColor: 'bg-purple-50' },
      { id: 'Services administratifs', label: 'Services administratifs', desc: 'Démarches, formalités', icon: FileText, color: 'text-green-500', bgColor: 'bg-green-50' },
      { id: 'Autre_Honoraires', label: 'Autre', desc: 'Autres honoraires et services', icon: MoreHorizontal, color: 'text-gray-500', bgColor: 'bg-gray-100' }
    ]
  },
  {
    id: 'Impôts & organismes',
    label: 'Impôts & organismes',
    description: 'Impôts, taxes et cotisations aux organismes publics',
    icon: Landmark,
    color: 'text-red-500',
    bgColor: 'bg-red-50',
    subcategories: [
      { id: 'Impôts & taxes', label: 'Impôts & taxes', desc: 'IRG, IBS, TVA...', icon: Receipt, color: 'text-pink-500', bgColor: 'bg-pink-50' },
      { id: 'CNAS', label: 'CNAS', desc: 'Cotisations CNAS', icon: Users, color: 'text-green-500', bgColor: 'bg-green-50' },
      { id: 'CASNOS', label: 'CASNOS', desc: 'Cotisations CASNOS', icon: Users, color: 'text-purple-500', bgColor: 'bg-purple-50' },
      { id: 'Timbres & droits', label: 'Timbres & droits', desc: 'Droits de timbre', icon: FileText, color: 'text-orange-500', bgColor: 'bg-orange-50' },
      { id: 'Taxes locales', label: 'Taxes locales', desc: 'TAP, taxes communales', icon: MapPin, color: 'text-blue-500', bgColor: 'bg-blue-50' },
      { id: 'Pénalités & majorations', label: 'Pénalités & majorations', desc: 'Pénalités de retard', icon: AlertTriangle, color: 'text-red-500', bgColor: 'bg-red-50' },
      { id: 'Autres organismes', label: 'Autres organismes', desc: 'Douanes, APN...', icon: Landmark, color: 'text-green-500', bgColor: 'bg-green-50' },
      { id: 'Autre_Impôts', label: 'Autre', desc: 'Autres impôts et organismes', icon: MoreHorizontal, color: 'text-gray-500', bgColor: 'bg-gray-100' }
    ]
  },
  {
    id: 'Matériel & investissements',
    label: 'Matériel & investissements',
    description: 'Achat d\'équipements, matériel et immobilisations',
    icon: Monitor,
    color: 'text-red-500',
    bgColor: 'bg-red-50',
    subcategories: [
      { id: 'Matériel informatique', label: 'Matériel informatique', desc: 'PC, imprimantes', icon: Laptop, color: 'text-purple-500', bgColor: 'bg-purple-50' },
      { id: 'Mobilier & agencement', label: 'Mobilier & agencement', desc: 'Mobilier, rayonnages', icon: Armchair, color: 'text-pink-500', bgColor: 'bg-pink-50' },
      { id: 'Matériel professionnel', label: 'Matériel professionnel', desc: 'Équipements, matériel', icon: Settings, color: 'text-blue-500', bgColor: 'bg-blue-50' },
      { id: 'Réfrigération & chaîne du froid', label: 'Réfrigération & chaîne du froid', desc: 'Réfrigérateurs, vitrines', icon: Snowflake, color: 'text-teal-500', bgColor: 'bg-teal-50' },
      { id: 'Climatisation', label: 'Climatisation', desc: 'Climatiseurs', icon: Fan, color: 'text-green-500', bgColor: 'bg-green-50' },
      { id: 'Travaux & aménagement', label: 'Travaux & aménagement', desc: 'Rénovation, travaux', icon: Hammer, color: 'text-orange-500', bgColor: 'bg-orange-50' },
      { id: 'Véhicule', label: 'Véhicule', desc: 'Achat de véhicule', icon: Car, color: 'text-red-500', bgColor: 'bg-red-50' },
      { id: 'Autres investissements', label: 'Autres investissements', desc: 'Autres matériels', icon: MoreHorizontal, color: 'text-gray-500', bgColor: 'bg-gray-100' }
    ]
  },
  {
    id: 'Autres',
    label: 'Autres',
    description: 'Autres dépenses non classées',
    icon: MoreHorizontal,
    color: 'text-gray-500',
    bgColor: 'bg-gray-100',
    subcategories: [
      { id: 'Autre_Dépense', label: 'Autre', desc: 'Autres dépenses non classées', icon: MoreHorizontal, color: 'text-gray-500', bgColor: 'bg-gray-100' }
    ]
  }
];

export const ALL_SUBCATEGORIES = EXPENSE_CATEGORIES.reduce((acc, cat) => {
  return [...acc, ...cat.subcategories];
}, []);

export const getExpenseVisuals = (subcategoryLabel) => {
  const match = ALL_SUBCATEGORIES.find(s => s.id === subcategoryLabel || s.label === subcategoryLabel);
  if (match) return match;

  const label = (subcategoryLabel || '').toLowerCase();
  
  if (label.includes('sonelgaz') || label.includes('electricité') || label.includes('gaz')) return ALL_SUBCATEGORIES.find(s => s.id === 'Électricité & Gaz');
  if (label.includes('internet') || label.includes('téléphone')) return ALL_SUBCATEGORIES.find(s => s.id === 'Téléphone & Internet');
  if (label.includes('loyer')) return ALL_SUBCATEGORIES.find(s => s.id === 'Loyer');
  if (label.includes('cnas') || label.includes('casnos')) return ALL_SUBCATEGORIES.find(s => s.label === 'CNAS') || ALL_SUBCATEGORIES.find(s => s.label === 'CASNOS');
  if (label.includes('impôt') || label.includes('taxes')) return ALL_SUBCATEGORIES.find(s => s.id === 'Impôts & taxes');
  if (label.includes('virement')) return ALL_SUBCATEGORIES.find(s => s.id === 'Virements');
  if (label.includes('salaire')) return ALL_SUBCATEGORIES.find(s => s.id === 'Salaire personnel');
  if (label.includes('médicament')) return ALL_SUBCATEGORIES.find(s => s.id === 'Médicaments');
  if (label.includes('transport')) return ALL_SUBCATEGORIES.find(s => s.id === 'Transport & carburant');
  if (label.includes('assurance')) return ALL_SUBCATEGORIES.find(s => s.id === 'Assurances');
  if (label.includes('maintenance')) return ALL_SUBCATEGORIES.find(s => s.id === 'Maintenance & réparations');
  if (label.includes('nettoyage')) return ALL_SUBCATEGORIES.find(s => s.id === 'Nettoyage & entretien');
  
  return {
    icon: MoreHorizontal,
    color: 'text-gray-500',
    bgColor: 'bg-gray-100',
    label: subcategoryLabel || 'Autre'
  };
};
